import React from "react";
import { Box, Typography, type SxProps, type Theme } from "@mui/material";
import CustomTwoColInput from "./CustomTwoColInput";
import { RequireIcon } from "@ippon/shared-assets";

export interface CustomTwoColInputGroupProps {
  label: string;
  firstName: string;
  lastName: string;
  placeholderOne: string;
  placeholderTwo: string;
  register: any;
  errors: any;
  marginBottom?: string | number;
  disabled?: boolean;
  isRequired?: boolean;
  isModalInput?: boolean;
  index?: number;
  labelWidth?: string;
  labelWidthSp?: string;
  inputWidth?: string;
  inputWidthSp?: string;
  onRemove?: (index: number) => void;
  validationMessageFirstName?: string;
  validationMessageLastName?: string;
  patternFirstName?: { value: RegExp; message: string };
  patternLastName?: { value: RegExp; message: string };
  sx?: SxProps<Theme>;
}

const CustomTwoColInputGroup: React.FC<CustomTwoColInputGroupProps> = ({
  label,
  firstName,
  lastName,
  placeholderOne,
  placeholderTwo,
  register,
  errors,
  marginBottom = "10px",
  disabled = false,
  isRequired = false,
  isModalInput = false,
  index,
  labelWidth,
  labelWidthSp,
  inputWidth,
  inputWidthSp,
  onRemove,
  validationMessageFirstName,
  validationMessageLastName,
  patternFirstName,
  patternLastName,
  sx,
}) => {
  const fieldIndex = typeof index === "undefined" ? 0 : index;
  return (
    <Box
      sx={{
        display: "block",
        marginBottom: marginBottom,
        width: { xs: "100%", sm: "inherit" },
        ...sx,
      }}
    >
      <Typography
        fontSize={12}
        className="modalInputLabel"
        color="#3E3E3E"
        fontWeight={700}
        sx={{
          display: "flex",
          alignItems: "center",
          width: (labelWidth || labelWidthSp) ? { lg: labelWidth ?? "100%", xs: labelWidthSp ?? "100%" } : "100%",
          marginBottom: 0,
          fontSize: "12px !important",
        }}
      >
        {label}
        {isRequired && fieldIndex === 0 && (
          <span style={{ display: "flex", marginLeft: "4px" }}>
            <RequireIcon />
          </span>
        )}
      </Typography>

      <Box
        sx={{
          width: { sm: inputWidth, xs: inputWidthSp },
          // mb: 1,
        }}
      >
        <CustomTwoColInput
          firstName={firstName}
          lastName={lastName}
          placeholderOne={placeholderOne}
          placeholderTwo={placeholderTwo}
          register={register}
          errors={errors}
          disabled={disabled}
          isModalInput={isModalInput}
          isRequired={isRequired}
          index={index}
          onRemove={onRemove}
          validationMessageFirstName={validationMessageFirstName ?? ""}
          validationMessageLastName={validationMessageLastName ?? ""}
          patternFirstName={patternFirstName}
          patternLastName={patternLastName}
        />
      </Box>
    </Box>
  );
};

export default CustomTwoColInputGroup;
